module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTkiIGhlaWdodD0iNTIiIHZpZXdCb3g9IjAgMCA1OSA1MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik01OC41IDIzLjExMTFINDAuOTVWMEgxNy41NVYyMy4xMTExSDBMMjkuMjUgNTJMNTguNSAyMy4xMTExWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrow.svg
// module id = owA6
// module chunks = 1